// extracted by mini-css-extract-plugin
export var avatarContainer = "_eg-0";
export var gray = "_eg-f";
export var green = "_eg-c";
export var icon = "_eg-9";
export var image = "_eg-1";
export var lg = "_eg-6";
export var md = "_eg-5";
export var presenceDot = "_eg-b";
export var red = "_eg-d";
export var sm = "_eg-4";
export var status = "_eg-a";
export var xl = "_eg-7";
export var xs = "_eg-3";
export var xxl = "_eg-8";
export var xxs = "_eg-2";
export var yellow = "_eg-e";